/* global axios */
import ApiClient from './ApiClient';

class IntelligenceDashboardAPI extends ApiClient {
  constructor() {
    super('intelligence_dashboard', { accountScoped: true, apiVersion: 'v2' });
  }

  filterParams({ since, until: untilTs, agentId, inboxId, ...rest } = {}) {
    return {
      since,
      until: untilTs,
      agent_id: agentId,
      inbox_id: inboxId,
      ...rest,
    };
  }

  getSummary(filters) {
    return axios.get(`${this.url}/summary`, { params: this.filterParams(filters) });
  }

  getConversationStates(filters) {
    return axios.get(`${this.url}/conversation_states`, {
      params: this.filterParams(filters),
    });
  }

  getOriginBreakdown(filters) {
    return axios.get(`${this.url}/origin_breakdown`, {
      params: this.filterParams(filters),
    });
  }

  getAgentManagement(filters) {
    return axios.get(`${this.url}/agent_management`, {
      params: this.filterParams(filters),
    });
  }

  getLabelsTop(filters) {
    return axios.get(`${this.url}/labels_top`, {
      params: this.filterParams(filters),
    });
  }

  getByChannelWeek(filters) {
    return axios.get(`${this.url}/conversations_by_channel_week`, {
      params: this.filterParams(filters),
    });
  }

  getHistoryByDay(filters) {
    return axios.get(`${this.url}/history_by_day`, {
      params: this.filterParams(filters),
    });
  }

  getAvgResponseTime(filters) {
    return axios.get(`${this.url}/avg_response_time`, {
      params: this.filterParams(filters),
    });
  }

  getFunnel(filters) {
    return axios.get(`${this.url}/funnel`, {
      params: this.filterParams(filters),
    });
  }

  getDrillDown({
    dimension,
    page,
    perPage,
    since,
    until: untilTs,
    agentId,
    inboxId,
    label,
    stage_index: stageIndex,
  }) {
    return axios.get(`${this.url}/drill_down`, {
      params: {
        dimension,
        page,
        per_page: perPage,
        since,
        until: untilTs,
        agent_id: agentId,
        inbox_id: inboxId,
        label,
        stage_index: stageIndex,
      },
    });
  }

  getConfig() {
    return axios.get(`${this.url}/dashboard_config`);
  }

  updateConfig({ wonLabelId, funnelStages }) {
    const payload = {};
    if (wonLabelId !== undefined) payload.won_label_id = wonLabelId;
    if (funnelStages !== undefined) payload.funnel_stages = funnelStages;
    return axios.post(`${this.url}/dashboard_config`, payload);
  }
}

export default new IntelligenceDashboardAPI();
